import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=33eb5188&scoped=true&"
import script from "./VersionInfo.vue?vue&type=script&lang=js&"
export * from "./VersionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eb5188",
  null
  
)

export default component.exports